import React, { Component } from 'react';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import SoftKnockPopup from './SoftKnockPopup.js';
import Call from './Call.js';

class Telehealth extends Component {
  /**************
   * Properties *
   **************/
  state = {
    navigationBar: {
      mainMenu: false,
      back: false,
      backRoute: '/main_menu',
    },
  };
  /**
   * Renders the component.
   *
   * @public
   *
   * @returns { React.Component }  The rendered view of the component.
   *
   */
  render() {
    return (
      <div className="service-1364">
        <Switch>
          <Route path="/telehealth/call" component={Call} />
          <Route path="/telehealth/softknock" component={SoftKnockPopup} />
          <Route
            path="/telehealth"
            render={() => <Redirect to="/telehealth/softknock" />}
          />
        </Switch>
      </div>
    );
  }
}

export default withRouter(Telehealth);
